module.exports = __webpack_public_path__ + "static/media/nestje1.9b377b27.jpg";